var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"user minus\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 21.0001V18.7779C17 17.5992 16.5505 16.4687 15.7503 15.6352C14.9502 14.8017 13.8649 14.3335 12.7333 14.3335H5.26667C4.13508 14.3335 3.04983 14.8017 2.24968 15.6352C1.44952 16.4687 1 17.5992 1 18.7779V21.0001",
    stroke: "#2A2E3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.00007 9.88887C11.3565 9.88887 13.2667 7.89903 13.2667 5.44444C13.2667 2.98984 11.3565 1 9.00007 1C6.64365 1 4.7334 2.98984 4.7334 5.44444C4.7334 7.89903 6.64365 9.88887 9.00007 9.88887Z",
    stroke: "#2A2E3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a589b8a6300d0845e3ab0ff64bb39023.svg";
export { ForwardRef as ReactComponent };